/**
 * Wire-format enums for project overheads.
 * Single source of truth for the values exchanged with the backend.
 */
export enum OverheadTypeDTO {
  INCOME = 'INCOME',
  COST = 'COST',
}

export enum OverheadStatusDTO {
  PENDING = 'PENDING',
  INVOICED = 'INVOICED',
  PLANNED = 'PLANNED',
  PAID = 'PAID',
}

/** Recurrence frequency on the wire. One-time overheads send no recurrence. */
export enum OverheadRecurrenceFrequencyDTO {
  WEEKLY = 'WEEKLY',
  MONTHLY = 'MONTHLY',
  QUARTERLY = 'QUARTERLY',
  YEARLY = 'YEARLY',
}

export type OverheadTypeRequest = OverheadTypeDTO;
export type OverheadTypeResponse = OverheadTypeDTO;

export type OverheadStatusRequest = OverheadStatusDTO;
export type OverheadStatusResponse = OverheadStatusDTO;

export type OverheadRecurrenceFrequencyRequest = OverheadRecurrenceFrequencyDTO;
